import "./Headerbox.css";
import React, { ReactNode } from "react";

interface HeaderboxProps {
  title: string;
  children: ReactNode;
}

class Headerbox extends React.Component<HeaderboxProps> {
  render() {
    return (
      <div className="box">
        <div className="header">
          <h2>{this.props.title}</h2>
        </div>
        {this.props.children}
      </div>
    );
  }
}

export default Headerbox;